<template>
    <div>
        {{ display }}
    </div>
</template>

<script>
import { format } from "@/formatting/durationFormatter";

export default {
    types: [
        "timespan",
    ],
    props: {
        value: {
            type: [ String ],
            default: null,
        }
    },
    computed: {
        display() {
            return format(this.value);
        }
    }
};
</script>